// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthButtonModuleScss from "../../styles/AuthButton.module.scss";
import * as EventsTrackerHelper$PorterinFeature from "../../../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";

var styles = AuthButtonModuleScss;

function AuthButtonCmp(Props) {
  var is_disabled = Props.is_disabled;
  var is_submittingOpt = Props.is_submitting;
  var class_name = Props.class_name;
  var event_name = Props.event_name;
  var category = Props.category;
  var submit_text = Props.submit_text;
  var click_handlerOpt = Props.click_handler;
  var event_label = Props.event_label;
  var mobileOpt = Props.mobile;
  var is_submitting = is_submittingOpt !== undefined ? is_submittingOpt : false;
  var click_handler = click_handlerOpt !== undefined ? click_handlerOpt : (function (param) {
        
      });
  var mobile = mobileOpt !== undefined ? mobileOpt : "";
  return React.createElement("button", {
              className: "" + styles.submit + " " + (
                is_disabled ? styles["submit-disabled"] : styles["submit-enabled"]
              ) + " " + (
                is_submitting ? styles["submit-loading"] : ""
              ) + " " + class_name + "",
              disabled: is_disabled,
              onClick: (function ($$event) {
                  Curry._1(click_handler, undefined);
                  PublishEventsHelper$PorterinFeature.publishEvents(category, event_name, event_label);
                  if (event_name === AuthStore$PorterinFeature.Login.ga_form_submit_event) {
                    EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.Login.ga_login_cta, {
                          fe_login_cta_confirm_tap: event_label
                        });
                    return EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.Login.moe_login_cta_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
                  } else if (event_name === AuthStore$PorterinFeature.OtpValidation.ga_form_submit_event) {
                    EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.OtpValidation.ga_login_otp_cta, {
                          fe_loginotp_cta_confirm_tap: event_label
                        });
                    return EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.OtpValidation.moe_form_submit_event_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
                  } else if (event_name === AuthStore$PorterinFeature.Signup.ga_form_submit_event) {
                    EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.Signup.ga_signup_cta, {
                          fe_loginsignup_cta_confirm_tap: event_label
                        });
                    return EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.Signup.moe_signup_cta_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
                  } else {
                    return ;
                  }
                })
            }, is_disabled && is_submitting ? React.createElement("div", {
                    className: styles.loading
                  }) : React.createElement("p", {
                    className: styles["submit-text"]
                  }, submit_text));
}

var make = AuthButtonCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
